import { useEffect, useState } from "react";
import style from '../CSS/RoundVideoResult.module.css'


const Details = ({ data, name, profile, subTitle }) => {
    const [items, setItems] = useState(null);

    useEffect(() => {
        setItems(data);
    }, [])
    return (
        <>
            {/* 636 */}
            <div className={style.details}>
                <div className={style.details__header}>
                    <div className={style.info}>
                        <div>
                            <img src={profile} alt="profile" />
                        </div>
                        <div>
                            <p>{name}</p>
                            <span>{subTitle}</span>
                        </div>
                    </div>
                    <div>
                        <p className={style.details__title}>Details</p>
                    </div>
                </div>
                <div>
                    <table className={style.table}>
                        <thead className={style.table__head}>
                            <tr>
                                <th>
                                    <p>Total videos</p>
                                </th>
                                <th>
                                    <p>Mark (Group A)</p>
                                </th>
                                <th>
                                    <p>Mark (Group B)</p>
                                </th>
                                <th>
                                    <p>Mark (Group C)</p>
                                </th>
                                <th>
                                    <p>Status</p>
                                </th>
                            </tr>
                        </thead>

                        <tbody className={style.table__body}>
                            {
                                items && items.length > 0 && items.map((item, index) => (
                                    <tr key={index} style={{ background: index % 2 == 0 && '#333030' }}>
                                        <td>{index + 1}. <img src={item.video} alt="" /></td>
                                        <td style={{ paddingLeft: '50px' }}>{item.markA}</td>
                                        <td style={{ paddingLeft: '50px' }}>{item.markB}</td>
                                        <td style={{ paddingLeft: '50px' }}>{item.markC}</td>
                                        <td style={{ textTransform: 'capitalize', color: item.status == 'yes' ? '#c4ffc5' : 'red' }}>{item.status}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>

        </>
    );
};

export default Details;